import { IError } from '../interfaces/error'
import cogoDefaultOptions from './toaster'
import cogoToast from 'cogo-toast'
import { TEXT } from './text'

function handleError(error: any): void {
	const errorData: IError = error?.request?.data || error?.response?.data
	const errorStatus: number = error?.request?.status || error?.response?.status
	const errorURL: string =
		error?.request?.config?.url || error?.response?.config?.url
		
	if(errorData?.error){
		cogoToast.error(errorData?.error, cogoDefaultOptions)
	}
	else if (!errorData) {
		//cogoToast.error(TEXT.SERVER_UNAVAILABLE, cogoDefaultOptions)
	} else if (errorStatus === 401) {
		cogoToast.error(TEXT.EXPIRED_SESSION, cogoDefaultOptions)		
	} else if (!/^5\d{2}/.test(errorStatus.toString())) {
		cogoToast.error(TEXT.SERVER_ERROR, cogoDefaultOptions)
	}
}

export default handleError
